import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const CommentRowContainerStyles: moduleStyleType = {
    comment: {
        paddingLeft: 4,
        marginTop: 2,
    },
    usernameItem: {
        marginRight: 2,
    },
}

export const TaskAuditStyles = {
    errorIcon: {
        color: palette.error.main,
    },
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        maxHeight: 'calc(90vh - 180px)',
    },
    reassignStepTextContainer: {
        minWidth: '20ch',
    },
    stepText: {
        ml: 1,
    },
}
